// extracted by mini-css-extract-plugin
export default {"notificationBell":"NotificationBell_notificationBell__sior8","badge":"NotificationBell_badge__P3-5a","link":"NotificationBell_link__9R6h4"};